export const data = [
	{
		"brand": "Aria",
		"style": [
			{
				"name": "Premium",
				"nominalPPS": 0.01,
				"rollSize": [
					{
						"name": "-",
						"ply": 2,
						"width": 4,
						"length": 4,
						"sheetsPerRoll": 308,
						"claimedEquiv": 1,
						"packSizes": [1],
						"nominalPricePerRoll": 1.11
					}
				]
			},
		]
	},
	{
		"brand": "AngelSoft",
		"style": [
			{
				"name": "-",
				"nominalPPS": 0.01,
				"rollSize": [
					{
						"name": "Double",
						"ply": 2,
						"width": 4,
						"length": 4,
						"sheetsPerRoll": 264,
						"claimedEquiv": 2,
						"packSizes": [1],
						"nominalPricePerRoll": 1.12
					},
					{
						"name": "Regular",
						"ply": 2,
						"width": 4,
						"length": 4,
						"sheetsPerRoll": 132,
						"claimedEquiv": 1,
						"packSizes": [1],
						"nominalPricePerRoll": 1.13
					},
					{
						"name": "Mega",
						"ply": 2,
						"width": 0,
						"length": 0,
						"sheetsPerRoll": 484,
						"claimedEquiv": 4,
						"packSizes": [1],
						"nominalPricePerRoll": 1.14
					}
				]
			},
		]
	},
	{
		"brand": "Charmin",
		"style": [
			{
				"name": "Essentials Soft",
				"nomimalPPS": 0.03,
				"nominalPricePerRoll": 0.75,
				"rollSize": [
					{
						"name": "Giant",
						"ply": 2,
						"width": 3.92,
						"length": 4,
						"sheetsPerRoll": 200,
						"claimedEquiv": 2.25,
						"packSizes": [1],
						"nominalPricePerRoll": 1.15
					}
				]
			},
			{
				"name": "Essentials Strong",
				"nominalPPS": 0.02,
				"rollSize": [
					{
						"name": "Giant",
						"ply": 1,
						"width": 3.92,
						"length": 4,
						"sheetsPerRoll": 300,
						"claimedEquiv": 2.583333,
						"packSizes": [1],
						"nominalPricePerRoll": 1.16
					}
				]
			},
			{
				"name": "Sensitive",
				"nominalPPS": 0.04,
				"rollSize": [
					{
						"name": "Mega",
						"ply": 2,
						"width": 3.92,
						"length": 3.95,
						"sheetsPerRoll": 300,
						"claimedEquiv": 4,
						"packSizes": [1],
						"nominalPricePerRoll": 1.17
					}
				]
			},
			{
				"name": "Ultra Soft",
				"nominalPPS": 0.05,
				"nominalPricePerRoll": 1.25,
				"rollSize": [
					{
						"name": "Double",
						"ply": 2,
						"width": 3.92,
						"length": 4,
						"sheetsPerRoll": 142,
						"claimedEquiv": 2,
						"packSizes": [1],
						"nominalPricePerRoll": 1.18
					},
					{
						"name": "Double Plus",
						"ply": 2,
						"width": 3.92,
						"length": 4,
						"sheetsPerRoll": 162,
						"claimedEquiv": 2.25,
						"packSizes": [1],
						"nominalPricePerRoll": 1.19
					},
					{
						"name": "Extra Value",
						"ply": 2,
						"width": 3.92,
						"length": 4,
						"sheetsPerRoll": 132,
						"claimedEquiv": 1,
						"packSizes": [1],
						"nominalPricePerRoll": 1.20
					},
					{
						"name": "Mega",
						"ply": 2,
						"width": 3.92,
						"length": 4,
						"sheetsPerRoll": 284,
						"claimedEquiv": 4,
						"packSizes": [1],
						"nominalPricePerRoll": 1.35
					},
					{
						"name": "Mega Plus",
						"ply": 2,
						"width": 3.92,
						"length": 4,
						"sheetsPerRoll": 326,
						"claimedEquiv": 4.5,
						"packSizes": [1],
						"nominalPricePerRoll": 1.22
					}
				]
			},
			{
				"name": "Ultra Strong",
				"nominalPPS": 0.06,
				"rollSize": [
					{
						"name": "Double",
						"ply": 2,
						"width": 3.92,
						"length": 4,
						"sheetsPerRoll": 154,
						"claimedEquiv": 2,
						"packSizes": [1],
						"nominalPricePerRoll": 1.23
					},
					{
						"name": "Extra Value",
						"ply": 2,
						"width": 3.92,
						"length": 4,
						"sheetsPerRoll": 132,
						"claimedEquiv": 1,
						"packSizes": [1],
						"nominalPricePerRoll": 1.24
					},
					{
						"name": "Mega",
						"ply": 2,
						"width": 3.92,
						"length": 4,
						"sheetsPerRoll": 308,
						"claimedEquiv": 4,
						"packSizes": [1],
						"nominalPricePerRoll": 1.25
					},
					{
						"name": "Mega Plus",
						"ply": 2,
						"width": 3.92,
						"length": 4,
						"sheetsPerRoll": 352,
						"claimedEquiv": 4.5,
						"packSizes": [1],
						"nominalPricePerRoll": 1.26
					}
				]
			},
		]
	},
	{
		"brand": "Cottonelle",
		"style": [
			{
				"name": "CleanCare",
				"nominalPPS": 0.07,
				"rollSize": [
					{
						"name": "Big",
						"ply": 1,
						"width": 3.82,
						"length": 4,
						"sheetsPerRoll": 150,
						"claimedEquiv": 1,
						"packSizes": [1],
						"nominalPricePerRoll": 1.27
					},
					{
						"name": "Family Roll",
						"ply": 1,
						"width": 0,
						"length": 0,
						"sheetsPerRoll": 250,
						"claimedEquiv": 1,
						"packSizes": [1],
						"nominalPricePerRoll": 1.28
					},
					{
						"name": "Double",
						"ply": 1,
						"width": 3.82,
						"length": 4,
						"sheetsPerRoll": 190,
						"claimedEquiv": 2,
						"packSizes": [1],
						"nominalPricePerRoll": 1.29
					},
					{
						"name": "Mega",
						"ply": 1,
						"width": 3.82,
						"length": 4,
						"sheetsPerRoll": 380,
						"claimedEquiv": 4,
						"packSizes": [1],
						"nominalPricePerRoll": 1.30
					}
				]
			},
			{
				"name": "GentleCare",
				"nominalPPS": 0.005,
				"rollSize": [
					{
						"name": "Mega",
						"ply": 1,
						"width": 3.82,
						"length": 4,
						"sheetsPerRoll": 408,
						"claimedEquiv": 4,
						"packSizes": [1],
						"nominalPricePerRoll": 1.31
					}
				]
			},
			{
				"name": "Ultra ComfortCare",
				"rollSize": [
					{
						"name": "Big",
						"ply": 2,
						"width": 3.82,
						"length": 4,
						"sheetsPerRoll": 126,
						"claimedEquiv": 1,
						"packSizes": [1],
						"nominalPricePerRoll": 1.32
					},
					{
						"name": "Double",
						"ply": 2,
						"width": 3.82,
						"length": 4,
						"sheetsPerRoll": 154,
						"claimedEquiv": 2,
						"packSizes": [1],
						"nominalPricePerRoll": 1.33
					},
					{
						"name": "Mega",
						"ply": 2,
						"width": 3.82,
						"length": 4,
						"sheetsPerRoll": 308,
						"claimedEquiv": 4,
						"packSizes": [1],
						"nominalPricePerRoll": 1.34
					}
				]
			},
		]
	},
	{
		"brand": "Quilted Northern",
		"style": [
			{
				"name": "Ultra Plush",
				"rollSize": [
					{
						"name": "Double",
						"ply": 3,
						"width": 0,
						"length": 0,
						"sheetsPerRoll": 154,
						"claimedEquiv": 2,
						"packSizes": [1],
						"nominalPricePerRoll": 1.35
					},
					{
						"name": "Mega",
						"ply": 3,
						"width": 4,
						"length": 4,
						"sheetsPerRoll": 330,
						"claimedEquiv": 4,
						"packSizes": [1],
						"nominalPricePerRoll": 1.36
					}
				]
			},
			{
				"name": "Ultra Soft & Strong",
				"rollSize": [
					{
						"name": "Double",
						"ply": 2,
						"width": 4,
						"length": 4,
						"sheetsPerRoll": 176,
						"claimedEquiv": 2,
						"packSizes": [1],
						"nominalPricePerRoll": 1.37
					},
					{
						"name": "Mega",
						"ply": 2,
						"width": 4,
						"length": 4,
						"sheetsPerRoll": 352,
						"claimedEquiv": 4,
						"packSizes": [1],
						"nominalPricePerRoll": 1.38
					}
				]
			},
		]
	},
	{
		"brand": "Scott",
		"style": [
			{
				"name": "1000 Sheets",
				"rollSize": [
					{
						"name": "Regular",
						"ply": 1,
						"width": 4.1,
						"length": 3.7,
						"sheetsPerRoll": 1000,
						"claimedEquiv": 1,
						"packSizes": [1],
						"nominalPricePerRoll": 1.39
					}
				]
			},
			{
				"name": "Extra Soft",
				"rollSize": [
					{
						"name": "Big",
						"ply": 1,
						"width": 3.82,
						"length": 4,
						"sheetsPerRoll": 202,
						"claimedEquiv": 1,
						"packSizes": [1],
						"nominalPricePerRoll": 1.40
					},
					{
						"name": "Mega",
						"ply": 1,
						"width": 3.82,
						"length": 4,
						"sheetsPerRoll": 528,
						"claimedEquiv": 4,
						"packSizes": [1],
						"nominalPricePerRoll": 1.41
					}
				]
			},
			{
				"name": "Extra Soft Dual Textured",
				"rollSize": [
					{
						"name": "Mega",
						"ply": 1,
						"width": 4.2,
						"length": 4,
						"sheetsPerRoll": 400,
						"claimedEquiv": 3,
						"packSizes": [1],
						"nominalPricePerRoll": 1.42
					}
				]
			},
			{
				"name": "Extra Soft Dri",
				"rollSize": [
					{
						"name": "Double",
						"ply": 1,
						"width": 4.2,
						"length": 4,
						"sheetsPerRoll": 264,
						"claimedEquiv": 1,
						"packSizes": [1],
						"nominalPricePerRoll": 1.43
					}
				]
			},
			{
				"name": "Rapid-Dissolving",
				"rollSize": [
					{
						"name": "Regular",
						"ply": 1,
						"width": 3.82,
						"length": 4,
						"sheetsPerRoll": 264,
						"claimedEquiv": 1,
						"packSizes": [1],
						"nominalPricePerRoll": 1.44
					}
				]
			},
			{
				"name": "Tube Free",
				"rollSize": [
					{
						"name": "",
						"ply": 0,
						"width": 0,
						"length": 0,
						"sheetsPerRoll": 0,
						"claimedEquiv": 2,
						"packSizes": [1]
					}
				]
			},
		]
	},
	{
		"brand": "Seventh Generation",
		"style": [
			{
				"name": "100% Recycled, Whitened",
				"rollSize": [
					{
						"name": "Double",
						"ply": 2,
						"width": 4,
						"length": 4,
						"sheetsPerRoll": 300,
						"claimedEquiv": 2,
						"packSizes": [1]
					}
				]
			},
			{
				"name": "Natural Unbleached",
				"rollSize": [
					{
						"name": "",
						"ply": 2,
						"width": 4,
						"length": 3.7,
						"sheetsPerRoll": 400,
						"claimedEquiv": 1,
						"packSizes": [1]
					}
				]
			},
		]
	},
	{
		"brand": "White Cloud",
		"style": [
			{
				"name": "Ultra Strong & Soft",
				"rollSize": [
					{
						"name": "Mega",
						"ply": 2,
						"width": 4,
						"length": 4,
						"sheetsPerRoll": 308,
						"claimedEquiv": 4,
						"packSizes": [1]
					}
				]
			},
			{
				"name": "Ultra 3 ply",
				"rollSize": [
					{
						"name": "Giant",
						"ply": 3,
						"width": 3.9,
						"length": 4,
						"sheetsPerRoll": 231,
						"claimedEquiv": 2.5,
						"packSizes": [1]
					}
				]
			},
			{
				"name": "Green Earth",
				"rollSize": [
					{
						"name": "Triple",
						"ply": 2,
						"width": 3.9,
						"length": 4,
						"sheetsPerRoll": 296,
						"claimedEquiv": 3,
						"packSizes": [1]
					}
				]
			},
			{
				"name": "2 ply Comfort Soft  Strong",
				"rollSize": [
					{
						"name": "Triple",
						"ply": 2,
						"width": 3.9,
						"length": 4,
						"sheetsPerRoll": 400,
						"claimedEquiv": 3,
						"packSizes": [1]
					}
				]
			},
		]
	}
]

export default data;